import { render, staticRenderFns } from "./ProviderMessageCenterModal.vue?vue&type=template&id=25bcda44&scoped=true&"
import script from "./ProviderMessageCenterModal.vue?vue&type=script&lang=js&"
export * from "./ProviderMessageCenterModal.vue?vue&type=script&lang=js&"
import style0 from "./ProviderMessageCenterModal.vue?vue&type=style&index=0&id=25bcda44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bcda44",
  null
  
)

component.options.__file = "ProviderMessageCenterModal.vue"
export default component.exports